import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FallbackView } from '../../_start/partials';
import { StartDashboardWrapper } from '../pages/dashboards/start-dashboard/StartDashboardWrapper';
import { QuotationManagementWrapper } from '../modules/quotation-management/QuotationManagementWrapper';
import { UserManagementWrapper } from '../modules/user-management/UserManagementWrapper';
import { PostManagementWrapper } from '../modules/post-management/PostManagementWrapper';
import { RoleAndPermissionWrapper } from '../modules/role-and-permission/RoleAndPermissionWrapper';
import { EmployeeManagementWrapper } from '../modules/employee-management/EmployeeManagementWrapper';
import { PageManagementWrapper } from '../modules/page-management/PageManagementWrapper';
import { ContentManagementWrapper } from '../modules/content-management/ContentManagementWrapper';
import { SettingsWrapper } from '../modules/settings/SettingsWrapper';
import { StorageTest } from '../pages/_testing/StorageTest';
import { LayoutManagementWrapper } from '../modules/layout-management/LayoutManagementWrapper';
import { MediaManagementWrapper } from '../modules/media-management/MediaManagementWrapper';
import { FormManagementWrapper } from '../modules/form-management/FormManagementWrapper';
import { ClientManagementWrapper } from '../modules/client-management/ClientManagementWrapper';
import { RedirectLinkManagementWrapper } from '../modules/redirect-link-management/RedirectLinkManagementWrapper';
import { GoogleMyBusinessWrapper } from '../pages/gmb/GoogleMyBusinessWrapper';

export function PrivateRoutes() {
  //   const BuilderPageWrapper = lazy(
  //     () => import('../pages/layout-builder/BuilderPageWrapper')
  //   );
  const ProfilePageWrapper = lazy(
    () => import('../modules/profile/ProfilePageWrapper')
  );
  //   const ChagePage = lazy(() => import('../modules/apps/chat/ChatPageWrapper'));
  //   const ShopPageWrapper = lazy(
  //     () => import('../modules/apps/shop/ShopPageWrapper')
  //   );
  //   const GeneralPageWrapper = lazy(
  //     () => import('../modules/general/GeneralPageWrapper')
  //   );
  //   const DocsPageWrapper = lazy(() => import('../modules/docs/DocsPageWrapper'));

  return (
    <Suspense fallback={<FallbackView />}>
      <Routes>
        <Route path="dashboard/*" element={<StartDashboardWrapper />} />

        <Route path="post-management/*" element={<PostManagementWrapper />} />

        <Route path="page-management/*" element={<PageManagementWrapper />} />

        <Route path="settings/*" element={<SettingsWrapper />} />

        <Route
          path="quotation-management/*"
          element={<QuotationManagementWrapper />}
        />

        <Route
          path="content-management/*"
          element={<ContentManagementWrapper />}
        />

        <Route path="user-management/*" element={<UserManagementWrapper />} />

        <Route
          path="role-and-permission/*"
          element={<RoleAndPermissionWrapper />}
        />

        <Route
          path="employee-management/*"
          element={<EmployeeManagementWrapper />}
        />

        <Route
          path="layout-management/*"
          element={<LayoutManagementWrapper />}
        />

        <Route path="media-management/*" element={<MediaManagementWrapper />} />

        <Route path="form-management/*" element={<FormManagementWrapper />} />

        <Route
          path="client-management/*"
          element={<ClientManagementWrapper />}
        />

        <Route
          path="redirect-link-management/*"
          element={<RedirectLinkManagementWrapper />}
        />

        <Route path="google-reviews/*" element={<GoogleMyBusinessWrapper />} />

        <Route path="test-storage/*" element={<StorageTest />} />

        <Route path="profile/*" element={<ProfilePageWrapper />} />

        <Route path="auth/*" element={<Navigate to="/dashboard" replace />} />
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/error/404" replace />} />
      </Routes>
    </Suspense>
  );
}
